import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { RootState } from '../index';
const { REACT_APP_API_URL } = process.env;

export const userManagementApi = createApi({
  reducerPath: 'userManagementApi',
  tagTypes: ['Users'],
  baseQuery: fetchBaseQuery({
    baseUrl: REACT_APP_API_URL,
    prepareHeaders: (headers, { getState }) => {
      const state = getState() as RootState;
      const token = state.auth.token;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getUsers: builder.query({
      query: (params) => ({
        url: 'api/user-management/get-users',
        method: 'GET',
        params,
      }),
      providesTags: ['Users'],
    }),
    getUserDetails: builder.query({
      query: (userId) => ({
        url: `api/user-management/get-users/${userId}`,
        method: 'GET',
      }),
      providesTags: ['Users'],
    }),
    updateUserDetails: builder.mutation({
      query: ({ formData, userId }) => ({
        url: `api/user-management/update-user/${userId}`,
        method: 'PUT',
        body: formData,
      }),
      invalidatesTags: ['Users'],
    }),
    passwordReset: builder.mutation({
      query: (userId) => ({
        url: `api/user-management/reset-user-password/${userId}`,
        method: 'GET',
      }),
    }),
    updateUserStatus: builder.mutation({
      query: ({ userId, status }) => ({
        url: `api/user-management/update-user-status/${userId}`,
        method: 'PUT',
        body: { status },
      }),
      invalidatesTags: ['Users'],
    }),
    addUser: builder.mutation({
      query: (userData) => ({
        url: `api/user-management/create-user`,
        method: 'POST',
        body: userData,
      }),
      invalidatesTags: ['Users'],
    }),
    deleteUser: builder.mutation({
      query: (userId) => ({
        url: `api/user-management/delete-user/${userId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Users'],
    }),
  }),
});

export const {
  useGetUsersQuery,
  useGetUserDetailsQuery,
  useUpdateUserStatusMutation,
  useAddUserMutation,
  useDeleteUserMutation,
  useUpdateUserDetailsMutation,
  usePasswordResetMutation,
} = userManagementApi;
